import { HeroLabel } from '../components/ds';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { ShowreelGrid } from '../components/showreel/ShowreelGrid';
import { buildShowreelPageSchema } from '../lib/schema';
import { SHOWREEL_META } from '../lib/seo';

export function ShowreelPage() {
  return (
    <MarketingLandingShell>
      <PageSeo meta={SHOWREEL_META} />
      <JsonLd data={buildShowreelPageSchema()} />
      <section className="band-dark pt-[calc(var(--shell-nav-offset)+1.25rem)] pb-10">
        <div className="container">
          <HeroLabel>Showreel</HeroLabel>
          <h1 className="font-headline font-medium text-[clamp(28px,4vw,44px)] leading-[0.95] tracking-[-0.03em] text-[#f2efea] m-0 mt-2 mb-2 max-w-[20ch]">
            Film made with Induce
          </h1>
          <p className="text-[14px] text-on-surface leading-[1.4] opacity-70 m-0 mb-6 max-w-[48ch]">
            Cuts from the Rhapsody Engine.
          </p>
          <ShowreelGrid />
        </div>
      </section>
    </MarketingLandingShell>
  );
}
